module.exports = __webpack_public_path__ + "static/rent-dd254515f4a912f10a9a88b9dcfa8cd7.jpg";